import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import NewsCard from "@/components/NewsCard";

export default function Search() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const { data } = await api.get(`/articles?q=${encodeURIComponent(q)}&limit=60`);
        setArticles(data);
      } finally {
        setLoading(false);
      }
    })();
  }, [q]);

  return (
    <div>
      <div className="border-b-2 border-primary pb-4 mb-8">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">Search</div>
        <h1 className="font-kannada-heading text-3xl mt-1">
          "{q}" ಗಾಗಿ ಫಲಿತಾಂಶಗಳು
        </h1>
      </div>
      {loading ? (
        <p className="text-muted-foreground">ಹುಡುಕುತ್ತಿದೆ...</p>
      ) : articles.length === 0 ? (
        <p className="text-muted-foreground">ಯಾವುದೇ ಸುದ್ದಿ ಸಿಗಲಿಲ್ಲ.</p>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="search-grid">
          {articles.map((a, i) => (
            <NewsCard key={a.id} article={a} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
